import * as z from 'zod';
export const connectionKind = z.enum(['openapi']);
export const connectionSpec = z.object({
    name: z.string(),
    kind: connectionKind
});
export const openapiConnectionSpec = connectionSpec.extend({
    url: z.string(),
    baseUrl: z.string(),
    headers: z.record(z.any()).optional(),
    schema: z.record(z.any()).optional()
});
//# sourceMappingURL=types.js.map